import { render } from "./NewFacilityForm.vue?vue&type=template&id=183388af&scoped=true"
import script from "./NewFacilityForm.vue?vue&type=script&lang=js"
export * from "./NewFacilityForm.vue?vue&type=script&lang=js"

import "./NewFacilityForm.vue?vue&type=style&index=0&id=183388af&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183388af"]])

export default __exports__